import type { CarrierPrice } from "~/shared/schemas/carrier-schema.ts";
import type { IdName } from "~/shared/schemas/generic-schema.ts";

import { ServiceLevel } from "../constants/carrier-selection-constants.ts";

export const getCarrierServiceLevelDisplayName = (
	carrierPrice: CarrierPrice,
): string => {
	// carrierPrice can originate from responses validated as `z.any()` (e.g. the
	// re-rate flow), so serviceLevel may be null at runtime despite its type.
	const serviceLevel = carrierPrice.serviceLevel as IdName | null;
	const serviceLevelName = serviceLevel?.name ?? "";

	const isDescriptionLevel =
		serviceLevel !== null &&
		[
			ServiceLevel.Volume,
			ServiceLevel.P44Pricing,
			ServiceLevel.SMCPricing,
		].includes(serviceLevel.id as ServiceLevel);

	const displayName = isDescriptionLevel
		? carrierPrice.serviceLevelDescription
		: serviceLevelName;

	return displayName
		? displayName
				.replace("SMC3", "")
				.replace("P44", "")
				.trim()
				.replace(" AM", "\u00A0AM")
				.replace(" PM", "\u00A0PM")
		: serviceLevelName;
};
